import { getDemoData } from 'utils/helpers';
import { DetailsItem } from 'elements/DetailsItem';
import { formatStudentHousingPropertyType } from 'utils/formatBooleanYesNo';
import styled from 'styled-components';

const displayValue = (value, isDemo, demoKey) => {
  if (isDemo && demoKey) return getDemoData(demoKey);
  if (value == null || String(value).trim() === '') return 'No Data';
  return value;
};

export const DetailCard = ({ building, isDemo }) => {
  return (
    <DetailCardContainer>
      <DetailsItem label="Phone" value={displayValue(building.phone, isDemo, 'phone')} />
      <DetailsItem
        label="Billing Street"
        value={displayValue(building.billingStreet, isDemo, 'address-street')}
      />
      <DetailsItem
        label="Email Address"
        value={displayValue(building.email_address, isDemo, 'email')}
      />
      <DetailsItem
        label="Secondary Email"
        value={displayValue(building.secondary_email, isDemo, 'email')}
      />
      <DetailsItem
        label="Operator Name"
        value={displayValue(building.landlord_name, isDemo, 'landlord-name')}
      />
      <DetailsItem
        label="Accounting Email"
        value={displayValue(building.accounting_email, isDemo, 'email')}
      />
      <DetailsItem
        label="Property Type"
        value={formatStudentHousingPropertyType(building.student_housing)}
      />
      <DetailsItem
        label="Billing State"
        value={displayValue(building.billingState, isDemo, 'address-state')}
        isLastItem
      />
    </DetailCardContainer>
  );
};

const DetailCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-radius: 2px;
  padding: 10px;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  background-color: rgba(248, 244, 249, 0.48);

  /* Four equal columns; long values ellipsize inside DetailsItem (LLP-189). */
  & > div {
    flex: 1 1 25%;
    max-width: 25%;
    min-width: 0;
  }

  @media screen and (max-width: ${(props) => props.theme.lg}) {
    justify-content: start;
    gap: 10px;
    & > div {
      border: none;
      flex: 1 1 20%;
      max-width: 20%;
      width: 20%;
      text-align: left;
      & > div {
        margin: 0;
      }
    }
  }

  @media screen and (max-width: ${(props) => props.theme.sm}) {
    & > div {
      flex: 1 1 100%;
      max-width: 100%;
      width: 100%;
    }
  }
`;
